var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivilegeNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 2.18649C13.5892 2.18649 10.5464 1.62753 8.19304 0.0584868C8.13588 0.0203515 8.0687 0 7.99999 0C7.93128 0 7.86411 0.0203515 7.80695 0.0584868C5.45356 1.62753 2.41078 2.18649 0.347826 2.18649C0.255577 2.18649 0.167106 2.22313 0.101876 2.28836C0.0366458 2.35359 0 2.44206 0 2.53431C0 8.83865 2.93948 13.862 7.86295 15.9719C7.90625 15.9904 7.95288 16 7.99999 16C8.04711 16 8.09373 15.9904 8.13704 15.9719C13.0605 13.862 16 8.83865 16 2.53431C16 2.44206 15.9633 2.35359 15.8981 2.28836C15.8329 2.22313 15.7444 2.18649 15.6522 2.18649ZM7.65217 0.973964V7.65222H1.45322C0.973546 6.10498 0.719454 4.49667 0.698782 2.87692C3.13538 2.80764 5.51985 2.15508 7.65217 0.973964ZM8.34782 15.103V8.34787H14.3068C13.28 11.2917 11.1409 13.7162 8.34782 15.1016V15.103Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegeNa);
export default __webpack_public_path__ + "static/media/privilege_na.a9d5fd59af53f516b851e5bdb78f5195.svg";
export { ForwardRef as ReactComponent };